/*
Summary:
The UTDJump is an input and button combo. The user selects a numerical value
of the granularity to jump to, and then presses either [ENTER] or the button.
The value is then cleared and the timeline and UTDBar shift to reflect the
desired position in time.
*/
import bigInt from "big-integer";
import React, { useRef } from "react";
import { toast } from "react-toastify";
import { IconButton } from "../../../_components";
import { useTime } from "../../../_contexts";
import { ChronosDate } from "../../../_helpers";

export function UTDJump({ disabled, parentRef, displayedUnits }) {
  const {
    granularity,
    calendar,
    currentDate,
    setCurrentDate,
    updateScrollPosition,
  } = useTime();

  const inputRef = useRef();

  const handleJump = (ev) => {
    if (inputRef.current) {
      console.group("-- UTD Jump --");
      let { value } = inputRef.current;
      value = parseInt(value, 10);
      if (isNaN(value)) {
        inputRef.current.value = "";
        toast.error("Digits only!!");
        return;
      }
      console.log("Received value: ", value, granularity, currentDate);
      // const unitDuration = calendar.time[granularity].duration;
      // const yearsInUnit = bigInt(unitDuration).divide(calendar.time.year.duration);
      // const updatedDate = bigInt(value).times(yearsInUnit)
      const date = new ChronosDate(currentDate, { calendar, logSteps: true });
      const newDate = date.jumpTo(value, granularity, displayedUnits); //desired point in time in seconds

      // console.log('UTDJump: To', granularity, value);
      // console.log("UTDJump: To", newDate, date);
      // const testDate = new ChronosDate(newDate, { calendar });
      // console.log("Date as object", testDate.toFullObject());
      if (parentRef.current) {
        const position = (value % displayedUnits) * 15;
        console.log(position);
        let newPosition = parentRef.current.setPosition(position);
        updateScrollPosition(newPosition);
      }
      const segment = new ChronosDate(newDate, {
        calendar,
        logSteps: true,
      }).getTimelineSegment(granularity, { unitCountDisplay: displayedUnits });
      // setCurrentDate(newDate);
      setCurrentDate(segment.start);
      console.log("Segment: ", segment);
      console.log("DONE");
      console.groupEnd();
      inputRef.current.blur();
      inputRef.current.value = "";
    }
  };

  const handleEnter = (ev) => {
    if (ev.key === "Enter") {
      handleJump(ev);
    }
  };

  const label =
    calendar && calendar.time[granularity]
      ? calendar.time[granularity].name
      : "";
  return (
    <div className="chronicle-utd-jump">
      <div className="input-group input-group-sm">
        <input
          className="form-control"
          ref={inputRef}
          placeholder={`Go to ${label}`}
          onKeyUp={handleEnter}
          disabled={disabled}
        />
        <div className="input-group-append">
          <IconButton
            icon="fas fa-triangle fa-rotate-90"
            onClick={handleJump}
          />
        </div>
      </div>
    </div>
  );
}
